module.exports = __webpack_public_path__ + "static/img/pic_pipei.47bda8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/suitability/pass/pic_pipei.png
// module id = 1596
// module chunks = 2